const VedgeProductPageHandler = (function() {
  'use strict';

  let productInfo = null;
  const variantPriceMap = [];

  return {
    init,
    addVariantPriceMapEntry,
    addVariantChangeListeners,
    getVariantPrice
  };

  ////////////////////////////////////////////////////////////////////////////

  function init(info) {
    productInfo = info;
  }

  function addVariantPriceMapEntry(variantId, price) {
    variantPriceMap[variantId] = price;
  }

  function addVariantChangeListeners(selectEl, chosenVariantEl) {
    selectEl.addEventListener("change", function() {
      _sendGoogleAnalyticsHitAfterVariantChange(chosenVariantEl.value);
    });
  }

  function getVariantPrice(variantId) {
    return variantPriceMap[variantId];
  }

  ////////////////////////////////////////////////////////////////////////////

  function _sendGoogleAnalyticsHitAfterVariantChange(variantId) {
    const productId = productInfo.id;
    const priceFull = getVariantPrice(variantId) / 100;

    VedgeAnalyticsHandler.pushViewItem(productId, variantId, priceFull);
  }

})();
